import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import React from "react";
import { FaLinkedin } from "react-icons/fa";

const FundInFocusGrowthToSale: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					Fund In Focus: From Growth to Scale - How Amara Partners is Redefining
					Mid-Market Investment in India
				</Heading>
				<Text
					fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
					fontWeight="600"
					color="white"
					lineHeight="21px"
				>
					Parag Shah, Partner,
					<Link href="https://amarapt.com/" target="_blank" rel="noreferrer">
						Amara Partners
					</Link>
				</Text>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Welcome to our ‘Fund in Focus’ series where we profile our member VC
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. Today we speak to Parag Shah, Partner of Amara
					Partners where he sheds light on the fund. Amara Partners is an
					India-focused mid-market private equity fund providing growth capital
					to businesses in sectors like manufacturing, financial services,
					consumer, and healthcare. With a philosophy rooted in
					institutionalizing companies, Amara Partners supports entrepreneurs
					with operational expertise, leadership development, and M&A
					strategies. Anchored by industry stalwarts like Anand Mahindra, the
					fund&apos;s unique blend of compounder and multiplier strategies
					ensures sustainable growth and value creation. Their focus is on
					profitable, cash-flow positive businesses ready for the next phase of
					growth.
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/ParagShah-BwjL6oGWkr2iS.jpg"
				alt="Parag Shah"
				boxSize="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="contain"
			/>
			<Box>
				<Flex flexDir={{ xs: "column", lg: "row" }} rowGap="16px">
					<Heading
						textAlign={{ xs: "center", md: "left" }}
						fontWeight="800"
						color="blue.400"
					>
						Spokesperson: Parag Shah, Partner,
						<Link href="https://amarapt.com/" target="_blank" rel="noreferrer">
							Amara Partners
						</Link>
					</Heading>
					<Flex
						columnGap={{ xs: "4px", md: "16px" }}
						justifyContent={{ xs: "center", md: "flex-start" }}
						transform={{ xs: "translateX(12px)", md: "none" }}
					>
						<Box alignSelf="start" mt="5px">
							<Link
								href="https://www.linkedin.com/in/parag-shah-1b96597/?originalSubdomain=in"
								target="_blank"
							>
								<IconButton
									aria-label="linkedin"
									icon={
										<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
									}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Box>
					</Flex>
				</Flex>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box>
					<Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
						1. What is the investment philosophy of Amara Partners?
					</Heading>
					<Text variant="blogAnswer" pb="20px">
						Amara Partners is an India focused mid-market private equity fund
						providing growth capital to businesses operating in Manufacturing,
						Financial Services, Consumer and Healthcare.
						<br />
						<br />
						Our investment philosophy has been shaped by our past experience in
						building the private equity arm at Mahindra Partners. Over 15 years
						we backed a diverse group of entrepreneurs through various sectors
						and stages of investment - from incubation to growth equity, to M&A,
						and turnarounds. Having seen 30+ journeys, we understand that the
						mid-market segment needs value-added capital, including operational
						expertise, leadership team development, supply chain optimization,
						building robust financial controls, processes and systems, and
						expansion via inorganic growth—in short, 'institutionalization'.
						<br /> <br />
						This approach has consistently proven to be a roadmap to success,
						and we want to continue the thesis at Amara. MSME’s in India will
						drive the next phase of growth, and we do see a large white space
						for capital to come in and create returns.
					</Text>
				</Box>
				{/* Question 2 */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						2. How has Mr Anand Mahindra’s involvement as an anchor limited
						partner shape the vision for the fund?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							Having Mr. Anand Mahindra join our Advisory board and being an
							anchor LP into Amara Partners was a tremendous validation for us.
							The leadership team at Amara Partners has cumulatively spent 45+
							years at the Mahindra Group. Mahindra Partners, essence and
							learnings led to the genesis & philosophy of Amara Partners, and
							therefore, our DNA is linked to what we learnt there.
							<br />
							<br />
							We intend on continuing the same strategy, philosophy, and culture
							where we:
							<br />
							<UnorderedList>
								<ListItem>
									<Text as="span" variant="blogAnswer" py="16px">
										Partner with strong entrepreneurs to support their next
										phase of growth.
									</Text>
								</ListItem>
								<ListItem>
									<Text as="span" variant="blogAnswer" py="16px">
										Do not tinker with the core of the business but help the
										founders in areas where they may not have deep experience.
									</Text>
								</ListItem>
								<ListItem>
									<Text as="span" variant="blogAnswer" py="16px">
										Help these businesses institutionalize.
									</Text>
								</ListItem>
							</UnorderedList>
							<br />
							We aim to create sustainable companies and deliver superior
							returns / create value for all stakeholders involved.
						</Text>
					</Box>
				</Box>

				{/* Question 3 */}

				<Box py="16px">
					<Heading variant="blogQuestion" pt="28px">
						3. Can you elaborate on Amara Partners’ core value proposition of
						institutionalizing businesses? How does this approach differentiate
						Amara from other funds in the mid-market and venture capital space?
					</Heading>
					<Box pt="16px">
						<Text variant="blogAnswer" pb="8px">
							Institutionalization can take many forms, and we recognize that
							every fund has its own model. First off, we do not tinker with the
							core of the business and promoter. We support them around the core
							in all areas where the promoters would either have not seen
							activity (such as M&A) or where we can bring in expertise which is
							an order higher than the current in-house team.
							<br /> <br />
							At Amara Partners, we have built our approach around a few core
							pillars that reflect our philosophy of long-term value creation.
							First is how we leverage our operating network to companies we
							work with. While we certainly bring people at the highest level
							for strategic advice and long-term vision, we would also
							collaborate in the more granular aspects of the business; whether
							it is improving factory-level efficiency, streamlining procurement
							processes or optimizing the supply chain; we engage and provide
							access to a deep pool of seasoned hands-on operators to bring the
							operating muscle. Another critical aspect of institutionalization
							is ensuring the business adopts processes, systems, and controls
							early on. Drawing from our experience of scaling and listing
							multiple companies, we have seen firsthand how valuable it is to
							instil such practices in a way that it becomes a way of life & is
							woven into the culture. Third, we have a playbook for helping
							companies in inorganic expansion. Most M&A’s fail post-acquisition
							as integration is a big hurdle. We have built a track record of
							setting up M&A teams, driving dozens of bolt-ons and ensuring
							basics such as incentive alignment & post-merger integration are
							taken care of. <br /> <br />A lot of these above practices are
							successfully prevalent in corporate India, and this is where we
							lean for experience and guidance. As we joke internally, for many
							years, we were a corporate with a PE mindset now we are a ‘PE with
							a corporate mindset.’
							<br /> <br />
							By focusing on ‘institutionalizing’ the business early and
							providing strategic and operational support, we ensure that these
							companies are prepared for decades of sustainable growth and
							long-term value creation.
						</Text>
					</Box>
				</Box>

				{/* Question 4 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							4. With stalwarts like Anand Mahindra, MM Murugappan, and Rafique
							Malik on your advisory board, how do you leverage their experience
							and networks in guiding investment decisions and portfolio
							companies?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								We have a marquee board of advisors and LP’s who are Industry
								stalwarts having built India’s largest institutions, more
								importantly they have done it with the highest level of
								governance and have created value for the entire ecosystem. We
								try and imbibe their ethos and marry it with our investment
								style to create steady, predictable, repeatable wins. The
								engagement is on multiple levels starting with sectoral insights
								and a live view on macro, which helps us flag any opportunities
								or stress that sectors might undergo. Second, from time to time,
								on selective opportunities we do get their feedback and advice.
								This could range from views on promoters, sectoral insights,
								reputational checks, and channel checks. Last and the most
								important, they serve as a phenomenal source of investment
								opportunities as well as ongoing advice. <br /> <br />
								As we onboard new limited partners from diverse backgrounds, our
								focus is to expand our LP base in a way where we can
								collectively add increasing value to our portfolio.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Question 5 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							5. Amara Partners employs both Compounder and Multiplier
							strategies in its investments. Could you explain how these
							strategies work together to build a balanced and high-growth
							portfolio?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								Our portfolio will be built on a core of Compounders: deals
								which comprise of companies that are established, cash flow
								positive profitable companies belonging to sectors where we have
								worked before. This would 70% of our investible capital and
								should result in our fund being returned with healthy returns.
								<br /> <br />
								30% of our capital would go to our Multipliers: Strategy for
								co-investment opportunities, where we look at high momentum
								companies with positive unit economics (and either profitable or
								with a clear path to profitability) and a strong cap table. This
								is the alpha creator in the portfolio and can help us deliver
								superlative returns
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Question 6 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							6. You are looking at sectors like manufacturing, financial
							services, consumer, and healthcare. What trends are you seeing in
							these areas that excite you, and how do you identify companies
							that fit into your investment thesis?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								We are extremely excited about the Indian manufacturing story.
								It is a perfect storm of internal capability meeting a rising
								demand, external factors shifting the supply chains from a
								unipolar to a more resilient model and political will to effect
								this change. India is one of the few countries that can offer
								scale comparable to China, making it an attractive alternative.
								The government is stepping up too with its Make in India
								initiative & PLI schemes designed to strengthen India’s
								manufacturing capability. Certain sub-segments such as
								Electronic Manufacturing, Auto Components, Packaging, Precision
								Engineering and Building Materials are quite active, and we are
								seeing healthy deal flow. Our investment in Lumax Auto, a Tier I
								auto-comp supplier was due to its robust fundamentals, strong
								R&D capabilities, and a strategic growth plan centred on
								building a platform.
								<br />
								<br />
								Financial Services is the backbone of the economy. India's
								banking sector is seeing strong credit growth in retail, SME
								segments, and an upswing in the real estate cycle. This presents
								opportunities in digital lending (personal and MSME), housing
								finance, and investment platforms for retail investors. Our
								investment in Fibe (EarlySalary), a leading fintech in consumer
								lending, aligns with our mission to provide reliable credit
								solutions and empower India's workforce.
								<br />
								<br />
								As India grows into the third-largest consumption economy, we
								are excited about some key trends: premiumization across
								categories like apparel, footwear, and jewellery; rising demand
								for new-age brands in staples, durables, and appliances
								especially displacing the traditional brands; and them expanding
								offline via GT and MT, showing the success of omni-channel
								presence. FirstCry, an investment we made at Mahindra Partners,
								is a perfect example of a consumer brand with a strong
								omnichannel presence, led by a solid founder who marries
								frugality with a clear focus on growth.
								<br /> <br />
								In healthcare, we have seen the success of single specialty
								chains with our investment in Centre for sight in from Mahindra
								Partners, and we are particularly bullish on this sub-segment.
								The investor interest in single specialty healthcare delivery in
								India stems from the well-established profitable unit economics
								in various sub-segments. Some key segments of interest include
								Mother & Child care, Oncology, IVF, and Eyecare.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Ques 7 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							7. What challenges and opportunities do mid-sized companies
							present, and how does Amara Partners plan to support these
							companies beyond just providing capital?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								Our entire raison d’etre is to provide value added capital to
								mid-market companies. The value being that we are a partner to
								the entrepreneur in what can be a very lonely journey. Our
								typical entrepreneur partner is a second-generation promoter who
								is steeped in the business, who like us is a steward (us of
								capital and them of their legacy) but are eager for growth and
								for taking their company to the next level. Our one endeavour is
								to provide them all the tools they would need and the capital to
								use these tools effectively.
								<br />
								<br />
								This can be in the form of experts (board members, advisors, key
								team members, consultants) who can guide on things ranging from
								the mundane (supply chain, procurement, systems, and processes)
								to the arcane (M&A, leadership transition, IPOs, new
								geographies).
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Ques 8 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							8. In some media reports it has been stated that Amara Partners
							offers strategic support in areas like technology, organization
							building, and inorganic expansion. Can you provide an example of
							how this hands-on approach has helped a portfolio company achieve
							its growth potential.
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								We partner with entrepreneurs and do not tinker with the core.
								We provide support around a functioning core business, making it
								stronger, helping it grow faster and institutionalizing it. This
								manifests in the form of the company becoming a target for later
								stage capital or being ready for a strategic partnership or to
								head to the capital markets to lead an independent life.
								<br />
								<br />
								There are multiple stories over the last two decades where we
								have made key interventions, have had success and failures, and
								these now get passed down to the team as learnings.
								<UnorderedList>
									<ListItem>
										<Text as="span" variant="blogAnswer" py="16px">
											A logistics company where we brought in a dramatically
											different approach to the prevalent thinking in the
											market: Taking an asset light, high ROCE approach. This
											was rewarded well as the company listed.
										</Text>
									</ListItem>
									<ListItem>
										<Text as="span" variant="blogAnswer" py="16px">
											A consumer internet platform where we were able to meld a
											large offline store presence with online leadership.
											Building out omnichannel capabilities before it became a
											buzzword.
										</Text>
									</ListItem>
									<ListItem>
										<Text as="span" variant="blogAnswer" py="16px">
											A healthcare chain, where we strengthen the M&A program
											via team member addition, sharpening the evaluation
											process and broadening the sourcing process. Brought in
											higher rigour as well as a higher volume of acquisitions.
										</Text>
									</ListItem>
									<ListItem>
										<Text as="span" variant="blogAnswer" py="16px">
											Multiple SaaS companies where we helped with GTM via our
											relationship with a large system integrator as well as
											helped set up later stage rounds through our ecosystem of
											funds.
										</Text>
									</ListItem>
								</UnorderedList>
								<br />
								Each of these companies was at a different stage and needed
								specific interventions. Working with founders as a partner and
								letting them play to their strengths has paid off.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Ques 9 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							9. With the first close target set at ₹400 crore, what are your
							plans for scaling the fund? How do you see Amara Partners evolving
							over the next few years in India’s dynamic private equity
							landscape?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								We see a gap in the sponsor ecosystem focusing on mid-market
								companies in India. The best operators now look for minimum
								cheques of anywhere between $50-100 MM whereas there is a sea of
								companies looking for $10-20 MM of value-added capital.
								<br />
								<br />
								This is the segment we would focus on and via our current fund,
								look to make 10 to 12 investments of around $7 to $10 MM each. A
								fund size of $100 MM (850 Cr) felt like the right mark. We are
								looking at a base target of INR 600 Cr and a greenshoe of INR
								250 Cr, we are currently through 80% of our base target.
								<br />
								<br />
								We see ourselves focusing on this mid-market segment and slowly
								growing our deal sizes as the economy naturally grows. There are
								going to be some interesting opportunities which can exploited,
								whether it is sector specialists focusing on manufacturing,
								climate, sustainability, healthcare, or capital which
								specializes in certain journeys such as pre-IPO, secondaries,
								etc.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Ques 10 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							10. Tell us the top three aspects Indian entrepreneurs and
							start-ups should keep in mind while approaching Amara Partners for
							funding.
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								We like to use a quip that we like “boring businesses with
								cashflow.” In clearer words, we like business which are in a
								stable industry, are profitable and are cashflow positive. What
								we also like is a desire for change, to go to the next orbit.
								<br />
								<br />
								We like second-generation entrepreneurs who are looking for a
								value-added partner to help them pilot their business into its
								next phase of growth.
								<br />
								<br />
								The three things to keep in mind, while approaching Amara
								Partners, are:
								<UnorderedList>
									<ListItem>
										<Text as="span" variant="blogAnswer" py="16px">
											Is your industry established? We bring in private equity /
											growth capital in established industries, not venture
											capital to change consumer behaviour or precipitate latent
											demand.
										</Text>
									</ListItem>
									<ListItem>
										<Text as="span" variant="blogAnswer" py="16px">
											Is your business model sorted? We back entrepreneurs who
											have their business model figured out and are looking for
											the next phase of growth. Their business is already
											profitable, cash accretive and needs capital and guidance
											to enter a new orbit.
										</Text>
									</ListItem>
									<ListItem>
										<Text as="span" variant="blogAnswer" py="16px">
											Are you ready for change? The hallmark of a successful
											entrepreneur is innate confidence but are they ready to
											bring in a partner and consider their advice, especially
											in areas outside their circle of competence.
										</Text>
									</ListItem>
								</UnorderedList>
							</Text>
						</Box>
					</Box>
				</Flex>
			</Box>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusGrowthToSale;
